import type { ReactNode } from 'react';
import Tooltip from '../toolTip';
import Dropdown from '../form-inputs/inputDropdown';
import { createEndSnapshotOptions } from '../../utils/helpers';
import type { OptionType } from '../../types/forms.type';

interface CampaignScopeProps {
  campaigns: { id: string; name: string; snapshot: string; rawSnapshot: string }[];
  snapshots: OptionType[];
  selectedCampaign: string;
  selectedSnapshots: { start: string; end: string };
  onCampaignChange: (campaignId: string) => void;
  onSnapshotsChange: (snapshotId: { start: string, end: string }) => void;
  children?: ReactNode;
}
export default function CampaignScope({
  campaigns, snapshots, selectedCampaign, selectedSnapshots, onCampaignChange, onSnapshotsChange, children,
}: CampaignScopeProps) {
  const campaignOptions = campaigns.map((campaign) => ({ value: campaign.id, label: campaign.name }));
  const campaign = campaigns.find((option) => option.id === selectedCampaign);
  const startSnapshot = campaign?.snapshot || '';
  const rawStartSnapshot = campaign?.rawSnapshot || '';

  const snapshotOptions = createEndSnapshotOptions(startSnapshot, snapshots);
  return (
    <div className="flex flex-col lg:flex-row lg:flex-wrap gap-6">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-end">
        <Dropdown
          id="campaign-dropdown"
          label="Campaign"
          placement="bottom"
          options={campaignOptions}
          selected={selectedCampaign}
          onChange={(_, value) => onCampaignChange(value?.value ?? '')}
        />
        <div id="campaign-start-snapshot" className="flex flex-col">
          <div className="pb-3 text-label text-secondary">Snapshots</div>
          <div className="input-default justify-between items-center bg-pipbg-subtle">
            <div className="flex gap-2 items-center text-pipgrey">
              <span className="font-semibold text-base font-nunito leading-[21px]">From:</span>
              <span className="text-body-large">{startSnapshot}</span>
            </div>
            <Tooltip label="campaign-snapshot" text="The start date is fixed to your campaign and cannot be changed." />
          </div>
        </div>
        <Dropdown
          id="outcome-tracker-end-snapshot-dropdown"
          prefix="To"
          label=""
          placement="bottom"
          options={snapshotOptions}
          selected={selectedSnapshots.end}
          onChange={(_, value) => onSnapshotsChange({ start: rawStartSnapshot, end: value?.value ?? '' })}
        />
      </div>
      {children}
    </div>
  );
}
